// extracted by mini-css-extract-plugin
export default {"root":"AskTeacherMain_root__XLYqf","tabs":"AskTeacherMain_tabs__XyEbv","ske":"AskTeacherMain_ske__WGNj7"};